import { Error } from "@/components/admin/error";
import { Notification } from "@/components/admin/notification";
import { Skeleton } from "@/components/ui/skeleton";
import { Suspense, type ReactNode } from "react";
import { ErrorBoundary } from "react-error-boundary";

import { useConfigurationLoader } from "../root/useConfigurationLoader";
import { NextStepPrompt } from "../deals/NextStepPrompt";
import { CommandPalette } from "./CommandPalette";
import { MobileNavigation } from "./MobileNavigation";
import { PwaUpdateToast } from "./PwaUpdateToast";
import { SkipLink } from "./SkipLink";

export const MobileLayout = ({ children }: { children: ReactNode }) => {
  useConfigurationLoader();
  return (
    <>
      <SkipLink />
      {/* Marg for sider som ikke har sin egen. Kunder og Oppgaver gjenbruker
          desktop-listene og sto helt inntil skjermkanten. Sider som har egen
          mobilmarg (MobileContent og e-post-/prospektsidene) er merket med
          data-mobile-padded og skal ikke få dobbel marg. pb-24 holder
          innholdet over bunnmenyen. */}
      <main
        id="main-content"
        tabIndex={-1}
        className="px-4 pt-4 pb-24 outline-none has-[[data-mobile-padded]]:p-0"
      >
        <ErrorBoundary FallbackComponent={Error}>
          <Suspense fallback={<Skeleton className="h-12 w-12 rounded-full" />}>
            {children}
          </Suspense>
        </ErrorBoundary>
      </main>
      <MobileNavigation />
      {/* Globalsøket (PR-S2): mobilens søkeinngang er Søk-knappen i navlinjen. */}
      <CommandPalette />
      <NextStepPrompt />
      <PwaUpdateToast />
      <Notification mobileOffset={{ bottom: "72px" }} />
    </>
  );
};
